import { lazy, Suspense } from "react";

import { AttentionWorkspacePage } from "../attention/attention-page.js";
import { LoadingState } from "../components/states.js";
import { DashboardPage } from "../dashboard/dashboard-page.js";
import { RecordsWorkspacePage } from "../records/records-page.js";
import { SetupWorkspacePage } from "../setup/setup-page.js";
import { TeamWorkspacePage } from "../team/team-page.js";
import { TasksWorkspacePage } from "../tasks/tasks-page.js";

const ReportsWorkspacePage = lazy(() =>
  import("../reports/reports-page.js").then((module) => ({
    default: module.ReportsWorkspacePage,
  })),
);
const BillingWorkspacePage = lazy(() =>
  import("../billing/billing-page.js").then((module) => ({
    default: module.BillingWorkspacePage,
  })),
);
const LoggingWorkspacePage = lazy(() =>
  import("../logging/logging-page.js").then((module) => ({
    default: module.LoggingWorkspacePage,
  })),
);
const PrivacyWorkspacePage = lazy(() =>
  import("../privacy/privacy-page.js").then((module) => ({
    default: module.PrivacyWorkspacePage,
  })),
);
const SettingsWorkspacePage = lazy(() =>
  import("../settings/settings-page.js").then((module) => ({
    default: module.SettingsWorkspacePage,
  })),
);

export function TodayPage() {
  return <DashboardPage />;
}

export function RecordsPage() {
  return <RecordsWorkspacePage />;
}

export function AttentionPage() {
  return <AttentionWorkspacePage />;
}

export function TasksPage() {
  return <TasksWorkspacePage />;
}

export function TeamPage() {
  return <TeamWorkspacePage />;
}

export function SetupPage() {
  return <SetupWorkspacePage />;
}

export function ReportsPage() {
  return (
    <Suspense fallback={<LoadingState label="Opening report builder" />}>
      <ReportsWorkspacePage />
    </Suspense>
  );
}

export function BillingPage() {
  return (
    <Suspense fallback={<LoadingState label="Opening billing" />}>
      <BillingWorkspacePage />
    </Suspense>
  );
}

export function LoggingPage() {
  return (
    <Suspense fallback={<LoadingState label="Opening record forms" />}>
      <LoggingWorkspacePage />
    </Suspense>
  );
}

export function PrivacyPage() {
  return (
    <Suspense fallback={<LoadingState label="Opening privacy workflows" />}>
      <PrivacyWorkspacePage />
    </Suspense>
  );
}

export function SettingsPage() {
  return (
    <Suspense fallback={<LoadingState label="Opening notification settings" />}>
      <SettingsWorkspacePage />
    </Suspense>
  );
}
